import { cn } from "@/lib/utils";

const TitleH3 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h3
      className={cn(
        "text-primary leading-[1.35] font-light tracking-normal text-[calc(22px*var(--heading-scale,1))] sm:text-[calc(24px*var(--heading-scale,1))] md:text-[calc(30px*var(--heading-scale,1))] xl:text-[calc(39px*var(--heading-scale,1))] xl:leading-[1.2308]",
        className,
      )}
    >
      {title}
    </h3>
  );
};

export default TitleH3;
